import { defineMessages } from 'react-intl'

/**
 * On-tile / on-PDP product badges (see `docs/product-taxonomy.md` §2). LE vs
 * white-label variants are separate keys: pick the right one at the call site.
 */
const productBadgeMessages = defineMessages({
  limitedTimeLuxExclusiveLe: {
    id: 'HfKQTJhSrYcq7b38i0nx',
    defaultMessage: 'Limited Time LUX Exclusive',
  },
  limitedTimeLuxExclusiveWl: {
    id: 'ELOGmElRhyYa89yQYHOq',
    defaultMessage: 'Limited Time Exclusive',
  },
  luxPremiumCollectionLe: {
    id: '0jJ1Jh_HXb3h9DjB0XXB',
    defaultMessage: 'LUX Premium Collection',
  },
  luxPremiumCollectionWl: {
    id: 'xpAmBYCbIAhmAcdsmzwV',
    defaultMessage: 'Premium Collection',
  },
  luxPartnerPropertyLe: {
    id: 'mJhLgeIBs6OHzRxl1lwU',
    defaultMessage: 'LUX Partner Property',
  },
  luxPartnerPropertyWl: {
    id: 'X0dft71-n3yhpjcLSvE5',
    defaultMessage: 'Partner Property',
  },
  luxExclusive: {
    id: '46ebreLwGtvpulRl_x0E',
    defaultMessage: 'LUX Exclusive',
  },
  luxTrustedPartner: {
    id: 'LwpI9uTLS5DzMFQUh7X2',
    defaultMessage: 'LUX Trusted Partner',
  },
  luxCollection: {
    id: 'kMTGjHTfmSzzG1dGdu1A',
    defaultMessage: 'LUX Collection',
  },
  ultraLuxBadgeAccessibilityLabel: {
    defaultMessage: 'Ultra Lux',
    id: 'Lya0JZkonxQZR_kP3MIx',
  },
  bundleAndSave: {
    id: 'NWHhUN-YWk-WLCZeyRst',
    defaultMessage: 'Bundle & Save',
  },
  limitedTimeSpecial: {
    id: 'oTAYW0h-XtuHGdkRFP-7',
    defaultMessage: 'Limited time special',
  },
  businessTravellerSpecial: {
    id: 'RSDZTaR-HjAxszAR140b',
    defaultMessage: 'Business Traveller Special',
  },
})

export default productBadgeMessages
